import { makeAutoObservable, runInAction } from 'mobx'
import type { Notify } from '@/Ship/Contracts/Notify'
import { DelegateExecutorTask } from '../Tasks/DelegateExecutorTask'

/**
 * Local store of `DelegateExecutorModal`.
 *
 * Delegates a `VehicleNeedExecutor` to another dispatcher by passing their IRI.
 * Only senior dispatchers / admins are allowed by the backend rule — the view
 * already gates this with `RequestExecutorPermissions.canDelegate`.
 */
export class DelegateExecutorModalStore {
    open = false
    executorUuid: string | null = null
    /** UUID диспетчера, що вже призначений на блок — виключаємо його зі списку вибору. */
    currentDispatcherUuid: string | null = null
    dispatcherIri = ''
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    openFor(executorUuid: string, currentDispatcherUuid?: string | null): void {
        this.executorUuid = executorUuid
        this.currentDispatcherUuid = currentDispatcherUuid ?? null
        this.dispatcherIri = ''
        this.loading = false
        this.open = true
    }

    close(): void {
        this.open = false
        this.executorUuid = null
        this.currentDispatcherUuid = null
        this.dispatcherIri = ''
        this.loading = false
    }

    setDispatcherIri(iri: string): void {
        this.dispatcherIri = iri
    }

    async delegate(notify: Notify, reload?: () => void): Promise<boolean> {
        if (!this.executorUuid) return false
        if (!this.dispatcherIri) {
            notify.error('Оберіть диспетчера')
            return false
        }
        this.loading = true
        try {
            await DelegateExecutorTask(this.executorUuid, this.dispatcherIri)
            notify.success('Делеговано')
            reload?.()
            this.close()
            return true
        } catch (e: any) {
            notify.error(e?.message || 'Не вдалося делегувати')
            runInAction(() => { this.loading = false })
            return false
        }
    }
}
